export const GET_ALL_BONRECEPTION_REQUEST = "GET_ALL_BONRECEPTION_REQUEST";
export const GET_ALL_BONRECEPTION_SUCCESS = "GET_ALL_BONRECEPTION_SUCCESS";
export const GET_ALL_BONRECEPTION_FAIL = "GET_ALL_BONRECEPTION_FAIL";

export const GET_BONRECEPTION_REQUEST = "GET_BONRECEPTION_REQUEST";
export const GET_BONRECEPTION_SUCCESS = "GET_BONRECEPTION_SUCCESS";
export const GET_BONRECEPTION_FAIL = "GET_BONRECEPTION_FAIL";

export const ADD_BONRECEPTION_REQUEST = "ADD_BONRECEPTION_REQUEST";
export const ADD_BONRECEPTION_SUCCESS = "ADD_BONRECEPTION_SUCCESS";
export const ADD_BONRECEPTION_FAIL = "ADD_BONRECEPTION_FAIL";

export const UPDATE_BONRECEPTION_REQUEST = "UPDATE_BONRECEPTION_REQUEST";
export const UPDATE_BONRECEPTION_SUCCESS = "UPDATE_BONRECEPTION_SUCCESS";
export const UPDATE_BONRECEPTION_FAIL = "UPDATE_BONRECEPTION_FAIL";

export const DELETE_BONRECEPTION_REQUEST = "DELETE_BONRECEPTION_REQUEST";
export const DELETE_BONRECEPTION_SUCCESS = "DELETE_BONRECEPTION_SUCCESS";
export const DELETE_BONRECEPTION_FAIL = "DELETE_BONRECEPTION_FAIL";

export const ADD_RCARTICLE_REQUEST = "ADD_RCARTICLE_REQUEST";
export const ADD_RCARTICLE_SUCCESS = "ADD_RCARTICLE_SUCCESS";
export const ADD_RCARTICLE_FAIL = "ADD_RCARTICLE_FAIL";

export const GET_RCARTICLE_REQUEST = "GET_RCARTICLE_REQUEST";
export const GET_RCARTICLE_SUCCESS = "GET_RCARTICLE_SUCCESS";
export const GET_RCARTICLE_FAIL = "GET_RCARTICLE_FAIL";

export const UPDATE_RCARTICLE_REQUEST = "UPDATE_RCARTICLE_REQUEST";
export const UPDATE_RCARTICLE_SUCCESS = "UPDATE_RCARTICLE_SUCCESS";
export const UPDATE_RCARTICLE_FAIL = "UPDATE_RCARTICLE_FAIL";

export const DELETE_RCARTICLE_REQUEST = "DELETE_RCARTICLE_REQUEST";
export const DELETE_RCARTICLE_SUCCESS = "DELETE_RCARTICLE_SUCCESS";
export const DELETE_RCARTICLE_FAIL = "DELETE_RCARTICLE_FAIL";
